import React from 'react';
import { Menu, Typography } from 'antd';
import NoImagePlaceholder from '@assets/no_image_placeholder.svg';
import MenuItems from './MenuItems';
import { useLoggedUser } from '@/hooks/user/useLoggedUser';
import { LogoGroup } from '../shared';

const Sidebar: React.FC = () => {
  const { tradingName, userType } = useLoggedUser();
  return (
    <aside className="w-[250px] bg-white fixed bottom-0 top-0 left-0 shadow-lg">
      <div className="flex flex-col py-4 px-6 text-center font-bold text-lg mt-1 align-center justify-center gap-2 mb-4">
        <LogoGroup
          containerClassName="items-center justify-center"
          virtualHubClassName="h-7 mb-4 shadow-md rounded-full"
          isatUClassName="h-7 mb-4 shadow-md rounded-full"
        />
        <Typography.Title
          level={4}
          className="text-center text-white font-bold"
        >
          VIRTUAL HUB
        </Typography.Title>
      </div>
      <Menu mode="vertical" theme="light" className="border-r-0">
        <MenuItems />
      </Menu>

      <div className="flex items-center gap-2 border-t p-4 absolute bottom-0 left-0 right-0">
        <img
          src={NoImagePlaceholder}
          className="w-8 h-8 rounded-full object-cover"
        />

        <div className="text-sm flex flex-col">
          <div>{tradingName}</div>
          <div className="text-gray-400">{userType?.toLowerCase()}</div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
